
export function register() {
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`
  
        navigator.serviceWorker
          .register(swUrl)
          .then((registration) => {
            console.log('✅ Service Worker registered:', registration)
  
            if (registration.waiting) {
              registration.waiting.postMessage({ type: 'SKIP_WAITING' })
  
              registration.waiting.addEventListener('statechange', (e: any) => {
                if (e.target.state === 'activated') {
                  window.location.reload()
                }
              })
            }
  
            registration.onupdatefound = () => {
              const installingWorker = registration.installing
              if (installingWorker) {
                installingWorker.onstatechange = () => {
                  if (
                    installingWorker.state === 'installed' &&
                    navigator.serviceWorker.controller
                  ) {
                    installingWorker.postMessage({ type: 'SKIP_WAITING' })
                  }
                }
              }
            }
          })
          .catch((error) => {
            console.error('❌ Service Worker registration failed:', error)
          })
      })
    }
  }
  